<template>
  <div class="aside-menu-area">
    <el-aside class="page-aside" width="auto">
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu class="page-aside-menu" router :collapse="collapse" :default-active="defaultActive" unique-opened>
          <template v-for="(menu, index) in menus" :key="index">
            <tq-page-aside-menu-item :userMenuPerms="permissions" :menuCountObj="menuCountObj"
              :menu="menu"></tq-page-aside-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </el-aside>
    <div class="page-aside__collapse">
      <el-tag v-if="!collapse" type="info" @click="collapseMenu">
        <i class="el-icon-caret-left"></i>
        收起
      </el-tag>
      <el-tag v-else type="info" @click="expandMenu">
        展开
        <i class="el-icon-caret-right"></i>
      </el-tag>
    </div>
  </div>
</template>

<script setup lang="ts">
import privateCapabilities from '@cttq/private-capabilities-v3';
import { computed, ref,watch, toRefs } from 'vue';
import { useRouter } from 'vue-router';


const globalState = privateCapabilities.userGlobalState().state
const router = useRouter()
type Props = {
  routes: Array<any>
  menuCountObj: any
  initCollapse: boolean
}

const props = withDefaults(defineProps<Props>(), {
  routes: () => [],
  menuCountObj: () => { },
  initCollapse: false
})

const { routes, initCollapse } = toRefs(props)

const defaultActive = ref<any>("")
const menus = ref<any[]>([])
const collapse = ref(false);

watch(() => initCollapse.value, (value:any) => {
  collapse.value = value
})

watch(() => routes.value, (newValue:any) => {
  if (newValue && newValue.length > 0) {
    if (newValue[0].meta.isMenu) {
      menus.value = newValue
    } else {
      menus.value = newValue[0].children
    }
  }
}, {
  immediate: true,
  deep: true,
})

watch(() => router.currentRoute.value.path, (val:any) => {
  if (router.currentRoute.value.meta && router.currentRoute.value.meta.hightLightPath) {
    defaultActive.value = router.currentRoute.value.meta.hightLightPath;
  } else {
    defaultActive.value = val
  }
}, {
  immediate: true,
  deep: true,
})


const collapseMenu = () => {
  collapse.value = true
}

const expandMenu = () => {
  collapse.value = false
}

const filterResourceCodes = (items:any[]):any[] => {
  let nodes:any = []
  items.forEach((item:any) => {
    nodes.push(item.resourceCode)
    if (item.childMenus && item.childMenus.length > 0) {
      const children = filterResourceCodes(item.childMenus)
      nodes = nodes.concat(children)
    }
  })
  return nodes
}


const permissions = computed(() => {
  if (globalState && globalState.userMenu) {
    const granted = globalState.userMenu;
    const nodes = filterResourceCodes(granted);
    return nodes;
  }
  return []
})


defineOptions({
  name: 'TqPageAsideMenu',
})
</script>
